import { render, staticRenderFns } from "./BookingNew.vue?vue&type=template&id=2b792c8c&scoped=true"
import script from "./BookingNew.vue?vue&type=script&lang=js"
export * from "./BookingNew.vue?vue&type=script&lang=js"
import style0 from "./BookingNew.vue?vue&type=style&index=0&id=2b792c8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b792c8c",
  null
  
)

export default component.exports